import { Text } from "@src/components";
import { formatElapsed } from "@visioni/a3s-monitoring/app";
import { EMPTY, formatInstant } from "../format";

/** An instant, followed by how long after `from` it came — e.g. "32s after received". */
export function TimelineValue({ from, at, sinceLabel }: { from: string; at: string | undefined; sinceLabel: string }) {
  if (at === undefined) {
    return (
      <Text textStyle="sm/regular" color="text">
        {EMPTY}
      </Text>
    );
  }
  const elapsed = formatElapsed(from, at);
  return (
    <Text textStyle="sm/regular" color="text" selectable>
      {formatInstant(at)}
      {elapsed !== undefined && (
        <Text textStyle="xs/regular" color="textMuted">
          {`  ${elapsed} ${sinceLabel}`}
        </Text>
      )}
    </Text>
  );
}
